<template>
  <div
    class="flex items-center gap-3 border-b border-gray-100 px-4 py-3 dark:border-dark-3"
  >
    <em
      class="mdi text-lg"
      :class="
        isFound
          ? 'mdi-check-circle text-green-500'
          : 'mdi-help-circle text-gray-400'
      "
    />
    <div class="flex-1 min-w-0">
      <div class="text-xs text-gray-500 dark:text-gray-400">
        {{ typeLabel }}
      </div>
      <div class="font-medium truncate">{{ serialNumber }}</div>
    </div>
    <div class="text-sm font-medium" :class="rssiColorClass">
      {{ rssi !== null ? `${rssi} dBm` : '-' }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { isStrongSignal } from '@/composables/useQTool';

const DEVICE_TYPE_LABELS: Record<string, string> = {
  SMOKE_DETECTOR: 'RWM',
  HEAT_COST_ALLOCATOR: 'HKV',
  WARM_WATER_METER: 'WWZ',
  WATER_METER: 'KWZ',
  HEAT_ENERGY_METER: 'WMZ',
  DIRECT_METER_GATEWAY: 'DMGW',
  SMART_RADIATOR_THERMOSTAT: 'SRT',
  LO_RA_WAN_GATEWAY: 'LRWGW',
  LEGACY_HEAT_ENERGY_METER: 'BG-WMZ',
  LEGACY_WARM_WATER_METER: 'BG-WWZ',
  LEGACY_WATER_METER: 'BG-KWZ',
  LEGACY_HEATING_PLANT_METER: 'BG-HAZ',
  LEGACY_WATER_PLANT_METER: 'BG-WAZ',
};

const props = defineProps<{
  serialNumber: string;
  type: string;
  rssi: number | null;
  isFound: boolean;
}>();

const typeLabel = computed(() => DEVICE_TYPE_LABELS[props.type] ?? props.type);

const rssiColorClass = computed(() => {
  if (props.rssi === null) return 'text-gray-400';
  return isStrongSignal(props.rssi) ? 'text-green-500' : 'text-red-500';
});
</script>
